var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":_vm.modalId,"hide-footer":""},on:{"show":_vm.onShow}},[_c('pwa-followers',{attrs:{"is-modal":true,"other-user-id":_vm.otherUserId,"other-username":_vm.otherUsername}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }